import axios from "axios"
import queryString from "query-string"
import * as appDataService from "@/AppDataService"
import * as utils from "@/Shared/utils"
import lodash from "lodash"
import {
  API_PROCESSING_RECORD,
  API_UPDATE_METADATA,
  API_CLONE_RECORD,
  API_ASSET_OFFERING,
  API_ERROR_EVENT,
  API_BILLING_ID,
  API_BILLING_ID_RANGE,
  API_ASSIGN_BILLING_ID,
  API_PUBLISH_RECORD
} from "./urls"

/**
 * retrieveProcessingRecords
 * @param {*} queryObjectInput
 * @param {*} serviceURL
 */
export function retrieveProcessingRecords(queryObjectInput, serviceURL) {
  return appDataService
    .getMPXUserInfo()
    .then(userInfo => {
      const token = userInfo.token
      let queryObject = {}
      if (!lodash.isUndefined(queryObjectInput)) {
        queryObject = queryObjectInput
      }
      queryObject["token"] = token
      queryObject["serviceURL"] = serviceURL
      let processingRecordsURL = utils.getServerUrl() + API_PROCESSING_RECORD
      processingRecordsURL += "?" + queryString.stringify(queryObject)
      let processingRecordsResponse = {}
      return axios
        .get(processingRecordsURL)
        .then(response => {
          processingRecordsResponse = response
          return processingRecordsResponse
        })
        .catch(error => {
          processingRecordsResponse = {}
          return Promise.reject(error)
        })
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

/**
 * createProcessingRecord - create a new processing record
 * @param {object} template
 * @returns {Promise}
 */
export function createProcessingRecord(reqBody, ownerId, serviceURL) {
  return appDataService
    .getMPXUserInfo()
    .then(userInfo => {
      const token = userInfo.token
      let queryObject = {}
      queryObject["token"] = token
      queryObject["serviceURL"] = serviceURL
      queryObject["ownerId"] = ownerId
      let assignBillingIdURL = utils.getServerUrl() + API_PROCESSING_RECORD
      assignBillingIdURL += "?" + queryString.stringify(queryObject)
      let createResponse = {}
      return axios
        .post(assignBillingIdURL, reqBody)
        .then(response => {
          createResponse = response
          return createResponse
        })
        .catch(error => {
          createResponse = {}
          return Promise.reject(error)
        })
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

/**
 * publishProcessingRecord - publish processing record
 * @param {object} template
 * @returns {Promise}
 */
export function publishProcessingRecord(reqBody, serviceURL) {
  return appDataService
    .getMPXUserInfo()
    .then(userInfo => {
      const token = userInfo.token
      let queryObject = {}
      queryObject["token"] = token
      queryObject["serviceURL"] = serviceURL
      let publishRecordURL = utils.getServerUrl() + API_PUBLISH_RECORD
      publishRecordURL += "?" + queryString.stringify(queryObject)
      let publishResponse = {}
      return axios
        .post(publishRecordURL, reqBody)
        .then(response => {
          publishResponse = response
          return publishResponse
        })
        .catch(error => {
          publishResponse = {}
          return Promise.reject(error)
        })
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

/**
 * cloneProcessingRecord - clone processing record
 * @param {object} template
 * @returns {Promise}
 */
export function cloneProcessingRecord(reqBody, serviceURL) {
  return appDataService
    .getMPXUserInfo()
    .then(userInfo => {
      const token = userInfo.token
      let queryObject = {}
      queryObject["token"] = token
      queryObject["serviceURL"] = serviceURL
      let cloneRecordURL = utils.getServerUrl() + API_CLONE_RECORD
      cloneRecordURL += "?" + queryString.stringify(queryObject)
      let cloneResponse = {}
      return axios
        .post(cloneRecordURL, reqBody)
        .then(response => {
          cloneResponse = response
          return cloneResponse
        })
        .catch(error => {
          cloneResponse = {}
          return Promise.reject(error)
        })
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

/**
 * deleteProcessingRecord
 * @param {*} queryObjectInput
 * @param {*} serviceURL
 */
export function deleteProcessingRecord(recordId, serviceURL) {
  return appDataService
    .getMPXUserInfo()
    .then(userInfo => {
      const token = userInfo.token
      let queryObject = {}
      queryObject["token"] = token
      queryObject["byId"] = recordId
      queryObject["serviceURL"] = serviceURL
      let processingRecordsURL = utils.getServerUrl() + API_PROCESSING_RECORD
      processingRecordsURL += "?" + queryString.stringify(queryObject)
      let processingRecordsResponse = {}
      return axios
        .delete(processingRecordsURL)
        .then(response => {
          processingRecordsResponse = response
          return processingRecordsResponse
        })
        .catch(error => {
          processingRecordsResponse = {}
          return Promise.reject(error)
        })
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

/**
 * assignBillingId - add template
 * @param {object} template
 * @returns {Promise}
 */
export function assignBillingId(reqBody, serviceURL) {
  return appDataService
    .getMPXUserInfo()
    .then(userInfo => {
      const token = userInfo.token
      let queryObject = {}
      queryObject["token"] = token
      queryObject["serviceURL"] = serviceURL
      let assignBillingIdURL = utils.getServerUrl() + API_ASSIGN_BILLING_ID
      assignBillingIdURL += "?" + queryString.stringify(queryObject)
      let assignBillingIdResponse = {}
      return axios
        .post(assignBillingIdURL, reqBody)
        .then(response => {
          assignBillingIdResponse = response
          return assignBillingIdResponse
        })
        .catch(error => {
          assignBillingIdResponse = {}
          return Promise.reject(error)
        })
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

/**
 * updateMetadata - add template
 * @param {object} template
 * @returns {Promise}
 */
export function updateMetadata(reqBody, account, serviceURL) {
  return appDataService
    .getMPXUserInfo()
    .then(userInfo => {
      const token = userInfo.token
      let queryObject = {}
      queryObject["token"] = token
      queryObject["serviceURL"] = serviceURL
      queryObject["account"] = account
      let assignBillingIdURL = utils.getServerUrl() + API_UPDATE_METADATA
      assignBillingIdURL += "?" + queryString.stringify(queryObject)
      let updateMetadataResponse = {}
      return axios
        .post(assignBillingIdURL, reqBody)
        .then(response => {
          updateMetadataResponse = response
          return updateMetadataResponse
        })
        .catch(error => {
          updateMetadataResponse = {}
          return Promise.reject(error)
        })
    })
    .catch(error => {
      return Promise.reject(error)
    })
}
/**
 * retrieveAssetOffers
 * @param {*} queryObjectInput
 * @param {*} serviceURL
 */
export function retrieveAssetOffers(queryObjectInput, serviceURL) {
  return appDataService
    .getMPXUserInfo()
    .then(userInfo => {
      const token = userInfo.token
      let queryObject = {}
      if (!lodash.isUndefined(queryObjectInput)) {
        queryObject = queryObjectInput
      }
      queryObject["token"] = token
      queryObject["serviceURL"] = serviceURL
      let assetOffersURL = utils.getServerUrl() + API_ASSET_OFFERING
      assetOffersURL += "?" + queryString.stringify(queryObject)
      let assetOffersResponse = {}
      return axios
        .get(assetOffersURL)
        .then(response => {
          assetOffersResponse = response
          return assetOffersResponse
        })
        .catch(error => {
          assetOffersResponse = {}
          return Promise.reject(error)
        })
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

/**
 * updateOffer - add template
 * @param {object} template
 * @returns {Promise}
 */
export function updateOffer(reqBody, serviceURL) {
  return appDataService
    .getMPXUserInfo()
    .then(userInfo => {
      const token = userInfo.token
      let queryObject = {}
      queryObject["token"] = token
      queryObject["serviceURL"] = serviceURL
      let assetOffersURL = utils.getServerUrl() + API_ASSET_OFFERING
      assetOffersURL += "?" + queryString.stringify(queryObject)
      let updateOfferResponse = {}
      return axios
        .put(assetOffersURL, reqBody)
        .then(response => {
          updateOfferResponse = response
          return updateOfferResponse
        })
        .catch(error => {
          updateOfferResponse = {}
          return Promise.reject(error)
        })
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

/**
 * retrievePreIngestErrors
 * @param {*} queryObjectInput
 * @param {*} serviceURL
 */
export function retrievePreIngestErrors(queryObjectInput, serviceURL) {
  return appDataService
    .getMPXUserInfo()
    .then(userInfo => {
      const token = userInfo.token
      let queryObject = {}
      if (!lodash.isUndefined(queryObjectInput)) {
        queryObject = queryObjectInput
      }
      queryObject["token"] = token
      queryObject["serviceURL"] = serviceURL
      let errorEventsURL = utils.getServerUrl() + API_ERROR_EVENT
      errorEventsURL += "?" + queryString.stringify(queryObject)
      let errorEventsResponse = {}
      return axios
        .get(errorEventsURL)
        .then(response => {
          errorEventsResponse = response
          return errorEventsResponse
        })
        .catch(error => {
          errorEventsResponse = {}
          return Promise.reject(error)
        })
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

/**
 * insertBillingIds - insert new billing ids
 * @param {object} template
 * @returns {Promise}
 */
export function insertBillingIds(reqBody, accountId, serviceURL) {
  return appDataService
    .getMPXUserInfo()
    .then(userInfo => {
      const token = userInfo.token
      let queryObject = {}
      queryObject["token"] = token
      queryObject["accountId"] = accountId
      queryObject["serviceURL"] = serviceURL
      let billingIdURL = utils.getServerUrl() + API_BILLING_ID
      billingIdURL += "?" + queryString.stringify(queryObject)
      let billingIdResponse = {}
      return axios
        .post(billingIdURL, reqBody)
        .then(response => {
          billingIdResponse = response
          return billingIdResponse
        })
        .catch(error => {
          billingIdResponse = {}
          return Promise.reject(error)
        })
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

/**
 * retrieveBillingIds
 * @param {*} queryObjectInput
 * @param {*} serviceURL
 */
export function retrieveBillingIds(queryObjectInput, serviceURL) {
  return appDataService
    .getMPXUserInfo()
    .then(userInfo => {
      const token = userInfo.token
      let queryObject = {}
      if (!lodash.isUndefined(queryObjectInput)) {
        queryObject = queryObjectInput
      }
      queryObject["token"] = token
      queryObject["serviceURL"] = serviceURL
      let billingIdURL = utils.getServerUrl() + API_BILLING_ID
      billingIdURL += "?" + queryString.stringify(queryObject)
      let billingIdsResponse = {}
      return axios
        .get(billingIdURL)
        .then(response => {
          billingIdsResponse = response
          return billingIdsResponse
        })
        .catch(error => {
          billingIdsResponse = {}
          return Promise.reject(error)
        })
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

/**
 * retrieveBillingIdsRange
 * @param {*} queryObjectInput
 * @param {*} serviceURL
 */
export function retrieveBillingIdsRange(queryObjectInput, serviceURL) {
  return appDataService
    .getMPXUserInfo()
    .then(userInfo => {
      const token = userInfo.token
      let queryObject = {}
      if (!lodash.isUndefined(queryObjectInput)) {
        queryObject = queryObjectInput
      }
      queryObject["token"] = token
      queryObject["serviceURL"] = serviceURL
      let billingIdRangeURL = utils.getServerUrl() + API_BILLING_ID_RANGE
      billingIdRangeURL += "?" + queryString.stringify(queryObject)
      let billingIdRangeResponse = {}
      return axios
        .get(billingIdRangeURL)
        .then(response => {
          billingIdRangeResponse = response
          return billingIdRangeResponse
        })
        .catch(error => {
          billingIdRangeResponse = {}
          return Promise.reject(error)
        })
    })
    .catch(error => {
      return Promise.reject(error)
    })
}



// WEBPACK FOOTER //
// ./src/PreIngest/PreIngestDataService.js